module.exports = __webpack_public_path__ + "static/the_dock-83358376a6324f3dd36918c6dff43a35.jpg";